const TYPES = {
    GET_ALERTS: 'GET_ALERTS',
    GET_ALERTS_COMPLETE: 'GET_ALERTS_COMPLETE',
    GET_ALERTS_FAILED: 'GET_ALERTS_FAILED',
    APPEND_TO_ALERT_LIST: 'APPEND_TO_ALERT_LIST',
    REMOVE_ALERTS: 'REMOVE_ALERTS',
    REMOVE_ALERTS_COMPLETE: 'REMOVE_ALERTS_COMPLETE'
};

export default {
    TYPES,

    getAlerts: (payload?) => ({
        type: TYPES.GET_ALERTS,
        payload
    }),

    getAlertsSuccess: (payload?) => ({
        type: TYPES.GET_ALERTS_COMPLETE,
        payload
    }),

    getAlertsFailed: (payload?) => ({
        type: TYPES.GET_ALERTS_FAILED,
        payload
    }),

    appendToAlertList: (payload?) => ({
        type: TYPES.APPEND_TO_ALERT_LIST,
        payload
    }),

    removeAlerts: (payload?) => ({
        type: TYPES.REMOVE_ALERTS,
        payload
    }),

    removeAlertsSuccess: (payload?) => ({
        type: TYPES.REMOVE_ALERTS_COMPLETE,
        payload
    })
};
